'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSubscribers = undefined;

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initSubscribers = exports.initSubscribers = function initSubscribers() {
  // PubSub.subscribe(prg.requestSuccess, (message, data) => {
  //   const { requestData: { action, quantity }, responseData: { price, product_id } } = data;

  //   if (action === 'add') {
  //     window.DY.API('event', {
  //       name: 'Add to Cart',
  //       properties: {
  //         quantity,
  //         currency: 'USD',
  //         productId: product_id.toString(),
  //         value: parseFloat((price / 100)).toFixed(2),
  //         dyType: 'add-to-cart-v1',
  //       },
  //     });
  //   }
  // });
};

// window.DY.API('event', {
//   name: 'Mobile Menu Opened',
//   properties: {
//     dyType: 'mobile-menu-opened'
//   },
// });

// window.DY.API('event', {
//   name: 'Size Guide',
//   properties: {
//     dyType: 'size-guide-v1'
//   },
// });

// window.DY.API('event', {
//   name: 'Yotpo Slider',
//   properties: {
//     dyType: 'yotpo-slider'
//   },
// });

// window.DY.API('event', {
//   name: 'Anniversary Hero CTA Clicked',
//   properties: {
//     dyType: 'anniversary-cta'
//   },
// });

// window.DY.API('event', {
//   name: 'Product Grid Item Add/Quickview',
//   properties: {
//     dyType: 'grid-item-cta'
//   },
// });

// window.DY.API('event', {
//   name: 'Inline Cart Facebook Click',
//   properties: {
//     dyType: 'inlineCart-hull-facebook'
//   },
// });

// window.DY.API('event', {
//   name: 'Inline Cart Google Click',
//   properties: {
//     dyType: 'inlineCart-hull-google'
//   },
// });
/* eslint-disable camelcase */